export class RequestRedeliveryPostModel {
  public RequestId?: number;
  public RedeliveryDate?: Date;
  public Status?: number;
  public RedeliveryRemark?: string;
}

export class RequestRedeliveryPutModel {
  public id?: number;
  public RequestId?: number;
  public RedeliveryDate?: Date;
  public RedeliveryRemark?: string;
  public Status?: number;
  public updatedBy?: string;
  public updatedDate?: Date;
}
